import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
// Self-hosted fonts (docs/08, CSP font-src 'self'): Sora (brand display face, variable weight), IBM Plex Sans 400/500/600.
import '@fontsource-variable/sora/wght.css';
import '@fontsource/ibm-plex-sans/400.css';
import '@fontsource/ibm-plex-sans/500.css';
import '@fontsource/ibm-plex-sans/600.css';
import '@immoaktas/ui-web/styles.css';
import './i18n';
import { App } from './App';
import { ENV } from './lib/env';
import { captureInAppFlag } from './lib/purchase';
import { watchStaleBuild } from './lib/staleBuild';

// before the router normalises the URL: remember `?app=1` from the mobile app (no web purchase there)
captureInAppFlag();
watchStaleBuild();
if (ENV.sentryDsn) {
  void import('@sentry/react').then((S) => S.init({ dsn: ENV.sentryDsn, tracesSampleRate: 0.1, sendDefaultPii: false }));
}
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
